import { render, staticRenderFns } from "./Calculators.vue?vue&type=template&id=f64fad54&scoped=true&"
import script from "./Calculators.vue?vue&type=script&lang=js&"
export * from "./Calculators.vue?vue&type=script&lang=js&"
import style0 from "./Calculators.vue?vue&type=style&index=0&id=f64fad54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64fad54",
  null
  
)

export default component.exports